module.exports = __webpack_public_path__ + "static/media/verset.500ba4ee.svg_old";